import React from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';

export function ToastProvider({ children }) {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={4000}
    >
      {children}
    </SnackbarProvider>
  );
}

// Custom hook that maintains API compatibility with old toast system
export function useToast() {
  const { enqueueSnackbar } = useSnackbar();

  return {
    success: (message, duration) => {
      enqueueSnackbar(message, {
        variant: 'success',
        autoHideDuration: duration || 4000,
      });
    },
    error: (message, duration) => {
      enqueueSnackbar(message, {
        variant: 'error',
        autoHideDuration: duration || 4000,
      });
    },
    warning: (message, duration) => {
      enqueueSnackbar(message, {
        variant: 'warning',
        autoHideDuration: duration || 4000,
      });
    },
    info: (message, duration) => {
      enqueueSnackbar(message, {
        variant: 'info',
        autoHideDuration: duration || 4000,
      });
    },
  };
}
